module.exports = __webpack_public_path__ + "img/web_ncyu_3.d8d0a641.jpg";